import type { PrefetchContext } from 'src/shared/prefetch';

import { prefetchFcm } from './hooks/fcm';
import { prefetchLogoFcm } from './hooks/logoVariation';

export async function prefetch(context: PrefetchContext): Promise<void> {
	await Promise.all([prefetchFcm(context), prefetchLogoFcm(context)]);
}
